export default __webpack_public_path__ + "static/media/FreightCar.256.851e0da4.png";